import React from 'react';
import useKidListFunctionality from '../../customHooks/kidListHook';

const KidImage = ({imageUrl, gender}) => {
    const { getImage } = useKidListFunctionality();
    return (
        <span className="d-child-thumb icon-wrap icon-rounded me-2 p-0 ratio ratio-1x1">
            <img
                src={getImage(imageUrl, gender)}
                alt=""
                className="img-fluid rounded-circle"
                onError={(event) => {
                    event.target.onerror = null
                    event.target.src = getImage("", gender)
                }}
            />
        </span>
    )
}

export default KidImage